// Checkbox.tsx
import React from 'react';
import { Checkbox as MUICheckbox, styled } from '@mui/material';
import Colors from '../global/Colors';
import Icon from '../global/Icon';

// Define the props interface
interface CheckboxProps {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  colorMode?: 'dark' | 'light';
  disabled?: boolean;
  size?: number; // pixel size for both width and height
  customIcon?: string;
}

// Styled wrapper that adapts to light/dark modes similar to Toggle
const Checkbox = styled(({ checked = false, onChange = () => {}, colorMode = 'light', disabled = false, size = 28.5, customIcon, ...props }: CheckboxProps) => {
  const isDark = colorMode === 'dark';
        
  const baseColor = isDark ? Colors.grey6 : Colors.grey2; 
  const checkedColor = isDark ? Colors.grey2 : Colors.grey6;

  const disabledIconColor = isDark ? Colors.white : Colors.black;

  const customIconSize = size*0.6;

  return (
    <MUICheckbox
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      icon={
        customIcon ? (
          <Icon icon={customIcon} color={baseColor} size={customIconSize} />
        ) : undefined
      }
      checkedIcon={
        customIcon ? (
          <Icon icon={customIcon} color={isDark ? Colors.black : Colors.white} size={customIconSize} />
        ) : undefined
      }
      {...props}
      sx={(theme) => {
        return {
          color: baseColor,
          padding: 0,
          width: size*0.8,
          height: size*0.8,
          '& .MuiSvgIcon-root': {
            fontSize: size,
          },
          '&.Mui-checked': {
            color: checkedColor,
            backgroundColor: customIcon ? checkedColor : 'transparent',
            borderRadius: customIcon ? '4px' : '0px',
          },
          '&.Mui-disabled': {
              color: disabledIconColor,
          },
        };
      }}
    />
  );
})(({ theme }) => ({}));

export default Checkbox;